export default {
  scoreLow: ' #FF0000',
  scoreMid: '#FFFF00',
  scoreHigh: '#33cc33',

  score: '#808080',
  score0: '#ff0000',
  score1: '#ff3300',
  score2: '#ff6600',
  score3: '#ff9900',
  score4: '#ffd400',
  score5: '#ffff00',
  score6: '#d5ff00',
  score7: '#aaff00',
  score8: '#88ee11',
  score9: '#66dd22',
  score10: '#33cc33',

  scorenone: '#000000',

  scorebw: '#808080',
  scorebw0: '#666',
  scorebw1: '#777',
  scorebw2: '#777',
  scorebw3: '#777',
  scorebw4: '#777',
  scorebw5: '#888',
  scorebw6: '#999',
  scorebw7: '#aaa',
  scorebw8: '#bbb',
  scorebw9: '#ccc',
  scorebw10: '#ddd',
};
